import svg from "./draft-material-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const DraftMaterialIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.data.dark,
);

export default DraftMaterialIcon;
